import React from 'react';
import './styles.css';

/**
 * Header for the Legend.
 *
 * @component
 * @category Legend
 */
const LegendHeader = () => {
  return (
    <>
      <div className="legend-header">
        <span>Legend</span>
      </div>
      <div className="legend-header-line" />
    </>
  );
};

export default LegendHeader;
